import React from 'react';
import classNames from 'classnames';

import styles from './Surface.module.scss';

export type ThemeSurface = 1 | 2;

// Context for current surface
const SurfaceContext = React.createContext<ThemeSurface>(1);

export const useCurrentSurface = () => React.useContext(SurfaceContext);

export interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> {
  children: React.ReactNode;
  surface?: ThemeSurface;
}
const Surface = React.forwardRef<HTMLDivElement, Props>(({ surface = 1, ...props }, ref) => (
  <SurfaceContext.Provider value={surface}>
    <div ref={ref} {...props} className={classNames(styles[`surface-${surface}`], props.className)}>
      {props.children}
    </div>
  </SurfaceContext.Provider>
));
export default Surface;
